class FirehawkCRMStockGrid {

	listElement = null
	pagination = null
	loadingOverlay = null

	categoryId = null

	totalPages = 0
	totalCategories = 0
	totalItems = 0
	page = -1
	pageSize = 16

	rootElement = null
	stockCategoryListElement = null
	stockCategoryPagination = null
	stockCategoryTotalPages = 0
	stockCategoryTotalItems = 0
	stockCategoryPage = -1
	stockCategoryPageSize = 16
	stockCategorySearchRequest = null
	stockCategoryPageItems = []
	stockCategoryDivider = null
	showOnlyCartStock = false

	stockSlug = "";
	loginSlug = "";

	searchRequest = null

	team = null

	pageItems = []

	defaultImageUrl = null
	currentLocation = null

	query = null

	dateLocale = null

	startDate = null
	endDate = null
	stockSorting = null
	categorySorting = null
	categoryTags = null

	hidePrices = false
	catalogOnlyMode = false
	showLoginToSeePrices = false

	parentCategoryId = null
	categoryId = null
	displayType = "grid"
	ignoreCategories = false;

	showImageDropshadow = false;

	addingToCart = {}

	constructor(rootElement, element, pagination, stockCategoryElement, stockCategoryPagination, stockCategoryDivider) {
		this.listElement = element
		this.pagination = pagination

		this.stockCategoryListElement = stockCategoryElement
		this.stockCategoryPagination = stockCategoryPagination
		this.stockCategoryDivider = stockCategoryDivider;
		this.rootElement = rootElement;

		this.loadingOverlay = jQuery(`<div class="loading-overlay"><i class="far fa-spinner-third fa-spin"></i></div>`)
		this.listElement.addClass("loading")
		this.listElement.append(this.loadingOverlay)
		this.stockCategoryListElement.addClass("loading")
		this.stockCategoryListElement.append(this.loadingOverlay)
		this.addListeners()
	}

	buildItem(item) {
		let displayImageView = ""
		let titleContainer = ""
		let stockCodeContainer = "";

		var displayImage = item.displayImage || this.defaultImageUrl
		let imageBackground = item.imageBackground || null;
		if (displayImage && displayImage.length) {
			if (imageBackground && imageBackground.length) {
				displayImageView = `<div class="top-img image-basic" style="background-image: url('${imageBackground}')"><div class="image-display-basic ${this.showImageDropshadow ? "dropshadow" : ""}" style="background-image: url('${displayImage}')"></div></div>`
			} else {
				displayImageView = `<div class="top-img image-basic"><div class="image-display-basic" style="background-image: url('${displayImage}')"></div></div>`
			}
		} else {
			displayImageView = '<div class="top-img placeholder image-basic" style="background: #f1f1f1;"></div>';
		}

		titleContainer += `<div class="title">${item.name}</div>`
		stockCodeContainer += `<div class="sku">${item.stockCode}</div>`


		let price = item.price;

		let addToCartButton = `<div class="fh-add-to-cart-wrapper">
      <button type="button" class="btn btn-primary fh-add-to-cart" data-stock="${item.id}">Add to Cart</button>
    </div>`;

		let hideAddToCartButton = false;

		if (this.hidePrices || this.catalogOnlyMode) {
			hideAddToCartButton = true;
		}

		if (hideAddToCartButton) {
			addToCartButton = "";
		}

		let stockOptions = `<div class="fh-stock-price">${price}</div>`
		if (this.hidePrices || this.showLoginToSeePrices) {
			stockOptions = ``
		}
		let loginToSeePrices = "";
		if (this.showLoginToSeePrices) {
			if (this.loginSlug && this.loginSlug.length) {
				loginToSeePrices += `<div class="login-to-see-prices"><a href="/${this.loginSlug}">Login to see prices</a></div>`
			} else {
				loginToSeePrices += `<div class="login-to-see-prices"><a href="">Login to see prices</a></div>`
			}
		}
		if (item._variations && item._variations.length > 1) {
			stockOptions += `<div class="subtitle p-0">${item._variations.length} Options</div>`
		}

		var content = `
			<div class="grid-item compact linked ${hideAddToCartButton ? 'no-cart' : ''}" id="grid-item-${item.id}" data-grid-stock-id="${item.id}" tabindex="0" tabindex="0">
				<div class="top-content">
						${displayImageView}
				</div>
        <div class="fh-stock-title-container">${titleContainer}</div>
        <div class="fh-stock-sku-container subtitle">${stockCodeContainer}</div>
        <div class="fh-stock-options">${stockOptions}</div>
        ${addToCartButton}
        ${loginToSeePrices}
			</div>
		`
		return content
	}

	buildCategoryGrid(items) {
		var gridItems = ""

		for (let item of items) {
			var view = this.buildCategoryItem(item)
			gridItems += `<div class="grid-col">${view}</div>`;
		}

		let content = `
		<div class="firehawk-crm-large-grid-view">
				${gridItems}
		</div>
		`

		jQuery(this.stockCategoryListElement).html(content)
	}

	buildCategoryItem(item) {
		let displayImageView = ""
		let titleContainer = ""

		var displayImage = item.displayImage || this.defaultImageUrl
		let imageBackground = item.imageBackground || "https://firebasestorage.googleapis.com/v0/b/fcrm-e17b0.appspot.com/o/_storage%2Fteam%2F-N35t1rxd-QpJeuIfCZ4%2F1673584422873-wise-product-gradient.png?alt=media&token=0f2187e2-d441-41c8-84c0-a9aea14599b7";
		if (displayImage && displayImage.length) {
			if (imageBackground && imageBackground.length) {
				displayImageView = `<div class="top-img image-basic" style="background-image: url('${imageBackground}')"><div class="image-display-basic ${this.showImageDropshadow ? "dropshadow" : ""}" style="background-image: url('${displayImage}')"></div></div>`
			} else {
				displayImageView = `<div class="top-img image-basic"><div class="image-display-basic" style="background-image: url('${displayImage}')"></div></div>`
			}
		} else {
			displayImageView = '<div class="top-img placeholder image-basic" style="background: #f1f1f1;"></div>';
		}

		titleContainer += `<div class="title">${item.name}</div>`

		var content = `
			<div class="grid-item compact stock-category-grid-item linked id="grid-item-${item.id}" data-grid-stock-category-id="${item.id}" tabindex="0" tabindex="0">
				<div class="top-content">
						${displayImageView}
				</div>
        <div class="fh-stock-title-container">${titleContainer}</div>
			</div>
		`
		return content
	}

	buildEntityListView(items) {
		var gridItems = ""
		for (let item of items) {
			var view = this.buildItem(item)
			gridItems += `<div class="grid-col">${view}</div>`
		}

		let content = `
		<div class="firehawk-crm-large-grid-view">
				${gridItems}
		</div>
		`

		jQuery(this.listElement).html(content)
	}

	addListeners() {
		jQuery(this.pagination).delegate('.fcrm-pagination-page', 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));

			if (!pageNumber || current.hasClass('disabled') || current.hasClass('active')) return;
			var newPage = pageNumber - 1
			this.getEntities(this.pageSize * newPage)
		})

		// Previous button click
		jQuery(this.pagination).delegate('.fcrm-pagination-previous', 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));

			if (!pageNumber || current.hasClass('disabled')) return;
			var newPage = pageNumber - 1
			this.getEntities(this.pageSize * newPage)
		});

		// Next button click
		jQuery(this.pagination).delegate('.fcrm-pagination-next', 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));
			if (!pageNumber || current.hasClass('disabled')) return;
			var newPage = pageNumber - 1
			this.getEntities(this.pageSize * newPage)
		});

		jQuery(this.listElement).delegate(".grid-item", "click", (event) => {
			let gridId = jQuery(event.currentTarget).data("grid-stock-id")
			if (gridId && gridId.length) this.openStockItemDetailView(gridId);
			// let gridItem = this.getGridItem(gridId)
			// if (gridItem) {
			//   this.openItemDetailModal(gridItem)
			// }
		})

		jQuery(this.listElement).delegate(".grid-item", "keypress", (event) => {
			let gridId = jQuery(event.currentTarget).data("grid-stock-id")

			// let gridItem = this.getGridItem(gridId)
			// if (gridItem) {
			//   this.openItemDetailModal(gridItem)
			// }

			if (event.which == 13) {
				if (gridId && gridId.length) this.openStockItemDetailView(gridId);
			}
		})

		jQuery(this.listElement).delegate(".fh-add-to-cart", 'click', (event) => {
			event.preventDefault()
			event.stopPropagation();
			var current = jQuery(event.currentTarget);
			let stockId = current.data("stock");
			this.addToCart(stockId, current);
		});

		jQuery(this.listElement).delegate(".view-cart-button", 'click', (event) => {
			event.stopPropagation();
		});


		jQuery(this.stockCategoryPagination).delegate('.fcrm-pagination-page', 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));

			if (!pageNumber || current.hasClass('disabled') || current.hasClass('active')) return;
			var newPage = pageNumber - 1
			this.getEntities(this.stockCategoryPageSize * newPage)
		})

		// Previous button click
		jQuery(this.stockCategoryPagination).delegate('.fcrm-pagination-previous', 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));

			if (!pageNumber || current.hasClass('disabled')) return;
			var newPage = pageNumber - 1
			this.getEntities(this.stockCategoryPageSize * newPage)
		});

		// Next button click
		jQuery(this.stockCategoryPagination).delegate('.fcrm-pagination-next', 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
			var pageNumber = jQuery.trim(current.attr('data-num'));
			if (!pageNumber || current.hasClass('disabled')) return;
			var newPage = pageNumber - 1
			this.getEntities(this.stockCategoryPageSize * newPage)
		});

		jQuery(this.stockCategoryListElement).delegate(".grid-item", "click", (event) => {
			let gridStockCategoryId = jQuery(event.currentTarget).data("grid-stock-category-id")
			if (gridStockCategoryId && gridStockCategoryId.length) this.openStockCategoryItemDetailView(gridStockCategoryId);
			// let gridItem = this.getGridItem(gridId)
			// if (gridItem) {
			//   this.openItemDetailModal(gridItem)
			// }
		})

		jQuery(this.stockCategoryListElement).delegate(".grid-item", "keypress", (event) => {
			let gridStockCategoryId = jQuery(event.currentTarget).data("grid-stock-category-id")

			// let gridItem = this.getGridItem(gridId)
			// if (gridItem) {
			//   this.openItemDetailModal(gridItem)
			// }

			if (event.which == 13) {
				if (gridStockCategoryId && gridStockCategoryId.length) this.openStockCategoryItemDetailView(gridStockCategoryId);
			}
		})

		jQuery(this.rootElement).delegate(".fh-searchbox", "keyup", (event) => {
			this.query = event.currentTarget.value;
			this.reloadView(0, this.query);
		})

		jQuery(this.rootElement).delegate(".fa-times-circle", 'click', (event) => {
			this.query = null;
			jQuery(this.rootElement).find(".fh-searchbox").val("");
			this.reloadView(0, this.query);
		});

		// jQuery(this.rootElement).children(".fh-searchbox").on('change, blur', function(e){ 
		// 	alert($(this).parents('div:first').attr('id'));
		// });

	}

	openStockItemDetailView(gridItem) {
		window.location.href = `/${this.stockSlug}?stock=${gridItem}`;
	}

	openStockCategoryItemDetailView(gridItem) {
		window.location.href = `./?category=${gridItem}`;
	}

	openItemDetailModal(gridItem) {
		let modalContainer = jQuery(this.listElement).parent(".firehawk-crm-cart")
		let modal = new FirehawkCRMStockDetailModal(gridItem, { container: modalContainer, defaultImage: this.defaultImageUrl })
		modal.show()
	}

	addToCart(stock, currentTarget) {
		if (this.addingToCart[stock] == true) return;
		this.addingToCart[stock] = true

		jQuery(currentTarget).addClass("loading")

		var params = {
			stock: stock
		};

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'add_to_cart',
				params: params
			}
		}).done((response) => {
			if (jQuery(currentTarget).parent().find(".view-cart-button").length == 0) {
				jQuery(currentTarget).after('<a class="btn btn-link view-cart-button" href="./fh-cart">View Cart</a>');
			}
		}).fail(() => {

		}).always(() => {
			jQuery(currentTarget).removeClass("loading")
			this.addingToCart[stock] = null
		})
	}

	getGridItem(itemId) {
		if (!itemId || !itemId.length) return null
		return this.pageItems.filter(e => e.id == itemId)[0]
	}

	getEntities(from) {
		// if (this.categoryId || this.ignoreCategories) {
		this.getStockItems(from)
		// } else {
		if (this.query && this.query.length) {
			this.clearCurrentStockCategoryGrid()
		} else {
			this.getCategories(from)
		}
		// }
	}

	getCategories(from) {
		this.stockCategoryListElement.addClass("loading")
		this.stockCategoryListElement.append(this.loadingOverlay)

		var params = {
			size: this.pageSize || 16,
			from: from || 0
		};

		if (this.categorySorting && Array.isArray(this.categorySorting)) {
			params["sort"] = this.categorySorting
		}

		if (this.categoryTags && Array.isArray(this.categoryTags)) {
			params["tags"] = this.categoryTags
		}

		if (this.categoryId && this.categoryId.length) {
			if (this.categoryId == "all" && this.parentCategoryId && this.parentCategoryId.length) {
				params["category"] = this.parentCategoryId
			} else {
				params["category"] = this.categoryId
			}
		}

		if (this.query) {
			params["query"] = this.query
		}

		var page = ((from || 0) / this.pageSize) || 0
		this.stockCategoryPage = page

		if (this.stockCategorySearchRequest) {
			this.stockCategorySearchRequest.abort()
		}

		this.stockCategorySearchRequest = jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'get_stock_categories',
				params: params
			}
		}).done((data) => {
			var results = []
			var total = 0

			if (data && data.results) {
				total = data.total || 0
				results = data.results
			}

			this.stockCategoryTotalItems = total
			this.stockCategoryTotalPages = Math.ceil(total / this.stockCategoryPageSize)
			this.stockCategoryPageItems = results

			if (this.stockCategoryTotalItems == 0) {
				this.stockCategoryListElement.hide();
				this.stockCategoryPagination.hide();
				this.stockCategoryDivider.hide();
			} else if (this.stockCategoryTotalItems <= this.stockCategoryPageSize) {
				this.stockCategoryListElement.show();
				this.stockCategoryPagination.hide();
				this.stockCategoryDivider.show();
			} else {
				this.stockCategoryListElement.show();
				this.stockCategoryPagination.show();
				this.stockCategoryDivider.show();
			}

			this.clearCurrentStockCategoryGrid()
			this.updatePagination(this.stockCategoryPage, this.stockCategoryTotalPages, this.stockCategoryPagination)
			this.buildCategoryGrid(results)

			this.loadingOverlay.hide()
			this.stockCategoryListElement.removeClass("loading")
		}).fail(() => {
			this.loadingOverlay.hide()
			this.stockCategoryListElement.removeClass("loading")
		})
	}

	getStockItems(from) {
		this.listElement.addClass("loading")
		this.listElement.append(this.loadingOverlay)
		this.loadingOverlay.show()

		var params = {
			size: this.pageSize || 16,
			from: from || 0,
			customTerms: []
		};

		if (this.query) {
			jQuery(this.rootElement).find(".fa-times-circle").show();
			params["query"] = this.query
		} else {
			jQuery(this.rootElement).find(".fa-times-circle").hide();
		}

		if (this.categoryId && this.categoryId.length) {
			if (this.categoryId == "all" && this.parentCategoryId && this.parentCategoryId.length) {
				params["category"] = this.parentCategoryId
			} else {
				params["category"] = this.categoryId
			}
		}

		if (this.showOnlyCartStock == true) {
			params.cartOnly = true
		}

		if (this.stockSorting && Array.isArray(this.stockSorting)) {
			params["sorting"] = this.stockSorting
		}

		var page = ((from || 0) / this.pageSize) || 0
		this.page = page

		if (this.searchRequest) {
			this.searchRequest.abort()
		}

		this.searchRequest = jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'get_category_stock',
				params: params
			}
		}).done((response) => {
			var results = []
			var total = 0

			if (response) {
				var data = JSON.parse(response);
				if (data && data.result) {
					total = data.total || 0
					results = data.result
				}
			}

			this.totalItems = total
			this.totalPages = Math.ceil(total / this.pageSize)
			this.pageItems = results

			if (this.totalItems == 0 || this.totalItems <= this.pageSize) {
				this.pagination.hide();
			} else {
				this.pagination.show();
			}

			this.clearCurrentGrid();
			this.updatePagination(this.page, this.totalPages, this.pagination)
			this.buildEntityListView(results)

			if (!results.length) {
				this.showEmptyListView()
			}
		}).fail(() => {
			this.loadingOverlay.hide()
			this.listElement.removeClass("loading")
		})

	}

	clearCurrentStockCategoryGrid() {
		this.stockCategoryListElement.html("")
	}

	clearCurrentGrid() {
		this.listElement.html("")
	}

	showEmptyListView() {
		let emptyView = jQuery(`<div class="empty-view">No items found</div>`)
		jQuery(this.listElement).html(emptyView)
	}

	getGridItemActions(itemId) {
		var actions = []
		if (!this.filterMyItems && this.user && this.user.roles) {
			var hasRole = false
			for (let i in this.user.roles) {
				let index = +i
				let role = this.user.roles[index]
				if (role == "supplier") {
					hasRole = true
					break
				}
			}

			if (hasRole) {
				actions.push({ action: "send-quote", title: "Send Quote" })
			}
		}

		return actions
	}

	updatePagination(page, totalPages, paginationElement) {
		if (!paginationElement) return;

		var self = this;
		var currentPage = page + 1
		var pageRange = 2;
		var totalPage = totalPages

		var rangeStart = currentPage - pageRange;
		var rangeEnd = currentPage + pageRange;

		if (rangeEnd > totalPage) {
			rangeEnd = totalPage;
			rangeStart = totalPage - pageRange * 2;
			rangeStart = rangeStart < 1 ? 1 : rangeStart;
		}

		if (rangeStart <= 1) {
			rangeStart = 1;
			rangeEnd = Math.min(pageRange * 2 + 1, totalPage);
		}

		var pageLink = ''
		var prevText = '&laquo;';
		var nextText = '&raquo;';
		var ellipsisText = '...';

		var activeClassName = 'active'
		var disableClassName = 'disabled'
		var showFirstOnEllipsisShow = true
		var showLastOnEllipsisShow = true
		var html = '';
		var i;

		// Whether to display header
		html += '<div class="fcrm-pagination-pages">';

		html += '<ul>';

		// Whether to display the Previous button
		if (currentPage <= 1) {

		} else {
			html += '<li class="fcrm-pagination-previous" data-num="' + (currentPage - 1) + '" title="Previous page"><a href="' + pageLink + '">' + prevText + '<\/a><\/li>';
		}


		// Whether to display the pages
		if (rangeStart <= 3) {
			for (i = 1; i < rangeStart; i++) {
				if (i == currentPage) {
					html += '<li class="fcrm-pagination-page ' + activeClassName + '" data-num="' + i + '"><a>' + i + '<\/a><\/li>';
				} else {
					html += '<li class="fcrm-pagination-page" data-num="' + i + '"><a href="' + pageLink + '">' + i + '<\/a><\/li>';
				}
			}
		} else {
			if (showFirstOnEllipsisShow) {
				html += '<li class="fcrm-pagination-first fcrm-pagination-page" data-num="1"><a href="' + pageLink + '">1<\/a><\/li>';
			}
			html += '<li class="fcrm-pagination-ellipsis ' + disableClassName + '"><a>' + ellipsisText + '<\/a><\/li>';
		}

		for (i = rangeStart; i <= rangeEnd; i++) {
			if (i == currentPage) {
				html += '<li class="fcrm-pagination-page ' + activeClassName + '" data-num="' + i + '"><a>' + i + '<\/a><\/li>';
			} else {
				html += '<li class="fcrm-pagination-page" data-num="' + i + '"><a href="' + pageLink + '">' + i + '<\/a><\/li>';
			}
		}

		if (rangeEnd >= totalPage - 2) {
			for (i = rangeEnd + 1; i <= totalPage; i++) {
				html += '<li class="fcrm-pagination-page" data-num="' + i + '"><a href="' + pageLink + '">' + i + '<\/a><\/li>';
			}
		} else {
			html += '<li class="fcrm-pagination-ellipsis ' + disableClassName + '"><a>' + ellipsisText + '<\/a><\/li>';

			if (showLastOnEllipsisShow) {
				html += '<li class="fcrm-pagination-last fcrm-pagination-page" data-num="' + totalPage + '"><a href="' + pageLink + '">' + totalPage + '<\/a><\/li>';
			}
		}


		if (currentPage >= totalPage) {

		} else {
			html += '<li class="fcrm-pagination-next" data-num="' + (currentPage + 1) + '" title="Next page"><a href="' + pageLink + '">' + nextText + '<\/a><\/li>';
		}

		html += '<\/ul><\/div>';

		if (totalPage > 1) {
			jQuery(paginationElement).html(html)
		} else {
			jQuery(paginationElement).html(html)
		}
	}

	reloadView(from, query = null) {
		this.query = query
		// this.buildEntityListView([])
		this.getEntities(from)
	}

	applyDateRange(startDate, endDate) {
		this.startDate = startDate
		this.endDate = endDate
		this.getEntities(0)
	}

	applyStockSorting(sorting) {
		this.stockSorting = sorting
		this.getEntities(this.page * this.pageSize)
	}

	search(query) {
		this.query = query
		this.getEntities(0)
	}

	setupView(size) {
		this.pageSize = size ? +size : 16
		this.stockCategoryPageSize = size ? +size : 16
		this.reloadView(0)
	}

}
